import { Observable } from 'rxjs';
import { StateObservable, ofType } from 'redux-observable';
import { mergeMap, concatMap, withLatestFrom } from 'rxjs/operators';
import * as release from '@webapp/sdk/release';
import * as categories from '@webapp/sdk/categories';
import { Action } from 'redux';
import {
  PublishRelease,
  PublishReleaseSuccess,
  PublishReleaseError,
} from '../action-creators';
import { PUBLISH_RELEASE } from '../actions';
import { hasActiveSubscription } from '../../subscription-manager/selectors';
import AppState from '../../state';

export const publishReleaseEpic = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, PublishRelease>(PUBLISH_RELEASE),
    withLatestFrom(state$),
    mergeMap(async ([action, state]) => {
      if (!hasActiveSubscription(state)) {
        return [new PublishReleaseError('No active subscription')];
      }
      try {
        if (!action.release.stores?.length) {
          const categoryStores = await categories.platforms();
          const stores = categoryStores.map((s) => s.metadata);

          action.release = {
            ...action.release,
            stores,
          };
        }
        await release.update(action.release);

        await release.validate(action.artistId, action.releaseId);

        const artists = await release.validateArtists(
          action.artistId,
          action.releaseId
        );

        await release.publish(
          action.artistId,
          action.releaseId,
          action.release
        );

        return [
          new PublishReleaseSuccess(action.artistId, action.releaseId, artists),
        ];
      } catch (err) {
        const errors: Action[] = [];
        if (
          err.message === 'RELEASE.VALIDATION_ERROR' ||
          err.message === 'RELEASE.UPCEAN_ALREADY_EXISTS' ||
          err.message === 'ASSET.NOT_FOUND'
        ) {
          errors.push(
            new PublishReleaseError(err.message, err.data?.description, action)
          );
        }
        return errors;
      }
    }),
    concatMap((actions) => actions)
  );
